import wait from './helpers/Wait';
import useDebounced from './hooks/useDebounced';
import useMounted from './hooks/useMounted';
import useRefFor from './hooks/useRefFor';
import useRouter from './hooks/useRouter';
import useThrottled from './hooks/useThrottled';
import useDOMSpy from './hooks/useDOMSpy';
import useTabFocus from './hooks/useTabFocus';
import useCountdown from './hooks/useCountdown';

export * from './components/Iframe';
export * from './components/Countdown';
export * from './components/Freeze';
export * from './components/If';
export * from './components/Memo';
export * from './components/EventProxy';
export * from './components/Wrapper';
export * from './components/Switch';
export * from './components/Try';

export {
  wait,
  useDOMSpy,
  useDebounced,
  useMounted,
  useRouter,
  useThrottled,
  useRefFor,
  useTabFocus,
};

export const useWindowFocus = useTabFocus;
